import { Pipe, PipeTransform } from '@angular/core';
import { Sconto, DefinizioneServizio } from '../models';

@Pipe({
	name: 'filterDefServizio',
	pure: false
})
export class ForFilterDefServizioPipe implements PipeTransform {
	transform(items: Array<DefinizioneServizio>, filter: string): any {
		if (!items || !filter) {
			return items;
		}
		return items.filter(item => item.tipologiaServizio.descrizione.toUpperCase().indexOf(filter.toUpperCase()) !== -1);
	}
}

@Pipe({
	name: 'filterScontoProfilo',
	pure: false
})
export class ForFilterScontoProfiloPipe implements PipeTransform {
	transform(items: Array<Sconto>, filter: string): any {
		if (!items || !filter) {
			return items;
		}
		return items.filter(item =>
			item.profilo.anagrafica.cognome.toUpperCase().indexOf(filter.toUpperCase()) !== -1
			|| item.profilo.anagrafica.nome.toUpperCase().indexOf(filter.toUpperCase()) !== -1
			|| item.profilo.anagrafica.cognome.concat(' ').concat(item.profilo.anagrafica.nome)
				.toUpperCase().indexOf(filter.toUpperCase()) !== -1
			|| item.profilo.anagrafica.nome.concat(' ').concat(item.profilo.anagrafica.cognome)
				.toUpperCase().indexOf(filter.toUpperCase()) !== -1);
	}
}

@Pipe({
	name: 'filterScontoTipoProfilo',
	pure: false
})
export class ForFilterScontoTipoProfiloPipe implements PipeTransform 
{
	transform(items: Array<Sconto>, filter: string): any {
		if (!items || !filter) {
			return items;
		}
		return items.filter(item => item.tipologiaProfilo.descrizione.toUpperCase().indexOf(filter.toUpperCase()) !== -1);
	}
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/pipes/for-filter.pipe.ts